export default __webpack_public_path__ + "static/media/chevron-right.892bbc73.svg";